import { detectTouchDevices } from './functions';


export class LarchSys {

    lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    isTouchDevice = false;

    // a simple services container:
    $factories: { [key: string]: LarchSysFunction } = {};
    $instances: { [key: string]: any } = {};

    constructor() {
        detectTouchDevices(isTouchDevice => {
            if (isTouchDevice) {
                $('body').addClass('use-touch');
                this.isTouchDevice = true;
            }
        });

        $(window).on("load", () => {
            $(window).trigger("resize");
            //$(window).trigger("scroll");
        });
    }

    map<T>(de: T, it: T, en: T): T {
        switch (this.lang) {
            default:
            case 'de': return de;
            case 'it': return it;
            case 'en': return en;
        }
    }

    load(features: LarchSysFeature[]) {
        for (const feature of features) {
            feature(this);
        }
    }


    registerService(name: string, factory: LarchSysFunction) {
        this.$factories[name] = factory;
    };

    getService<T = any>(name: string): T {
        let service = this.$instances[name];
        if (!service) {
            const factory = this.$factories[name];
            if (!factory) throw new Error(`No service for '${name}' registered!`);
            this.$instances[name] = service = factory(this);
        }

        return service as T;
    };
}

export type LarchSysFeature = (
    LarchSysFunction
);

export type LarchSysFunction = (larchSys: LarchSys) => void;